/**
 * API Configuration
 * Dynamically determines the API base URL based on the current environment
 */

// Get the current hostname to determine which API to use
const getApiBaseUrl = (): string => {
  const hostname = window.location.hostname;
  console.log('getApiBaseUrl - hostname:', hostname);
  console.log('getApiBaseUrl - full URL:', window.location.href);
  
  // Production environments
  if (hostname.includes('admin.bigfunwin.com')) {
    console.log('getApiBaseUrl - matched admin.bigfunwin.com');
    return 'https://api.bigfunwin.com/';
  } else if (hostname.includes('admin3.rjjautomated.games')) {
    console.log('getApiBaseUrl - matched admin3.rjjautomated.games');
    return 'https://api3.rjjautomated.games/';
  } else if (hostname.includes('admin.rjjautomated.games')) {
    console.log('getApiBaseUrl - matched admin.rjjautomated.games');
    return 'https://api.rjjautomated.games/';
  } else if (hostname.includes('admin2.rjjautomated.games')) {
    console.log('getApiBaseUrl - matched admin2.rjjautomated.games');
    return 'https://api2.rjjautomated.games/';
  } else if (hostname.includes('admin1.rjjautomated.games')) {
    console.log('getApiBaseUrl - matched admin1.rjjautomated.games');
    return 'https://api1.rjjautomated.games/';
  } else if (hostname.includes('bfw-admin.vercel.app') || hostname.includes('bfw-admin')) {
    console.log('getApiBaseUrl - matched bfw-admin Vercel instance');
    return 'https://api.bigfunwin.com/';
  }
  
  // Development environments
  if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
    console.log('getApiBaseUrl - matched localhost');
    return 'http://localhost:8000/';
  }
  
  // Fallback to environment variable or default
  const envApiUrl = process.env.REACT_APP_API_BASE_URL;
  console.log('getApiBaseUrl - envApiUrl:', envApiUrl);
  if (envApiUrl) {
    console.log('getApiBaseUrl - using envApiUrl:', envApiUrl);
    return envApiUrl;
  }
  
  // Check for Vercel deployments that might not be explicitly configured
  if (hostname.includes('vercel.app') || hostname.includes('vercel')) {
    console.log('getApiBaseUrl - detected Vercel deployment, using BigFunWin API');
    return 'https://api.bigfunwin.com/';
  }
  
  // Default fallback
  console.log('getApiBaseUrl - using default fallback');
  return 'https://api.bigfunwin.com/';
};

const baseApiUrl = getApiBaseUrl();

// Force HTTPS - aggressive safety check
let API_BASE_URL = baseApiUrl;
if (API_BASE_URL.startsWith('http://')) {
  API_BASE_URL = API_BASE_URL.replace('http://', 'https://');
  console.warn('⚠️ HTTP URL detected and converted to HTTPS:', baseApiUrl, '→', API_BASE_URL);
}

// Log the API URL being used (for debugging)
console.log(`Admin Panel API Base URL: ${API_BASE_URL}`);
console.log(`Original API Base URL: ${baseApiUrl}`);
console.log(`URL was changed from HTTP to HTTPS: ${baseApiUrl !== API_BASE_URL}`);

export { API_BASE_URL };

export default API_BASE_URL;
